angular.module('FlexyBeautyApp.services')
    .factory('SaleDelivery',function () {
        return {
            ADDRESS            : "address",
            SITE               : "site",
            ADDRESS_SEND       : "address-send"
        };
    });


// WEBPACK FOOTER //
// ./js/services/views/ConstantsSaleDelivery.js